import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.location = 'https://www.fablestreet.com/';
  }, []);

  return <p>Redirecting ....</p>;
}
